<template>
  <collapsible-widget
    title="WYSZUKIWANIE"
    :accordion="accordion"
    :default-expanded="true"
    ><template v-if="true"
      ><b-btn
        class="collapse-btn w-100"
        variant="success"
        v-b-toggle.collapse-address-search
        @click="toggleAddressSearchCollapsed"
      >
        Wyszukiwanie adresów
        <icon
          class="ml-1"
          v-show="addressSearchExpanded"
          name="caret-up"
        ></icon>
        <icon
          class="ml-1"
          v-show="!addressSearchExpanded"
          name="caret-down"
        ></icon>
      </b-btn>
      <b-collapse id="collapse-address-search">
        <address-search></address-search> </b-collapse
    ></template>

    <template v-if="objectSearchTool && !isMobileVersion">
      <b-btn
        class="collapse-btn w-100"
        variant="success"
        v-b-toggle.collapse-features-form
        @click="toggleFeaturesCollapsed"
      >
        Wyszukiwanie obiektów
        <icon class="ml-1" v-show="featuresExpanded" name="caret-up"></icon>
        <icon class="ml-1" v-show="!featuresExpanded" name="caret-down"></icon>
      </b-btn>
      <div class="overlayed-loader" v-show="fetchinFeaturesData">
        <icon
          class="overlayed-loader-icon"
          name="circle-notch"
          scale="2"
          spin
        ></icon>
      </div>
      <b-collapse
        id="collapse-features-form"
        :class="{ blur: fetchinFeaturesData }"
      >
        <!-- <b-btn
          class="collapse-btn w-100"
          variant="light"
          v-b-toggle.collapse-coordinate-search
          @click="toggleCoordinatesSearchCollapsed"
          v-if="!contextIsAnonymous"
        >
          Za pomocą współrzędnych
          <icon
            class="ml-1"
            v-show="coordinateSearchExpanded"
            name="caret-up"
          ></icon>
          <icon
            class="ml-1"
            v-show="!coordinateSearchExpanded"
            name="caret-down"
          ></icon>
        </b-btn>
        <b-collapse id="collapse-coordinate-search">
          <coordinate-search></coordinate-search>
        </b-collapse> -->

        <!-- <b-btn
          class="collapse-btn w-100"
          variant="light"
          v-b-toggle.collapse-mileage-search
          @click="toggleMileageSearchCollapsed"
        >
          Wyszukiwanie na podst. kilometrażu drogi
          <icon
            class="ml-1"
            v-show="mileageSearchExpanded"
            name="caret-up"
          ></icon>
          <icon
            class="ml-1"
            v-show="!mileageSearchExpanded"
            name="caret-down"
          ></icon>
        </b-btn>
        <b-collapse id="collapse-mileage-search">
          <mileage-search></mileage-search>
        </b-collapse> -->

        <b-btn
          class="collapse-btn w-100"
          variant="light"
          v-b-toggle.collapse-teryt-search
          @click="toggleTerytSearchCollapsed"
        >
          Lokalizowanie obiektów
          <icon
            class="ml-1"
            v-show="terytSearchExpanded"
            name="caret-up"
          ></icon>
          <icon
            class="ml-1"
            v-show="!terytSearchExpanded"
            name="caret-down"
          ></icon>
        </b-btn>
        <b-collapse id="collapse-teryt-search">
          <teryt-search v-if="terytSearchExpanded"></teryt-search>
        </b-collapse>
      </b-collapse>
    </template>
    <template v-if="metadataSearchTool && false">
      <b-btn
        variant="success"
        class="collapse-btn w-100"
        v-b-toggle.collapse-metadata-form
        @click="toggleMetadataCollapsed"
      >
        Wyszukiwanie metadanych
        <icon class="ml-1" v-show="metadataExpanded" name="caret-up"></icon>
        <icon class="ml-1" v-show="!metadataExpanded" name="caret-down"></icon>
      </b-btn>
      <div class="overlayed-loader" v-show="fetchingData">
        <icon
          class="overlayed-loader-icon"
          name="circle-notch"
          scale="2"
          spin
        ></icon>
      </div>
      <b-collapse id="collapse-metadata-form" @hidden="clear">
        <b-form
          id="metadata-form"
          @submit="submit"
          :class="{ blur: fetchingData }"
        >
          <b-alert variant="danger" :show="downloadErrors"
            >{{ downloadErrorMessage }}
            <b-link class="alert-link" @click="refresh">Kliknij</b-link> aby
            odświeżyć.</b-alert
          >
          <b-alert variant="danger" :show="apiError"
            >Błąd wyszukiwania metadanych.</b-alert
          >
          <b-form-group label="Adres usługi" label-for="service-url">
            <small class="text-danger" v-show="serviceNotSelected"
              >Należy wybrać usługę.</small
            >
            <b-form-select
              id="service-url"
              size="sm"
              v-model="service"
              :options="services"
            >
              <template slot="first">
                <option :value="null" disabled>Wybierz</option>
              </template>
            </b-form-select>
          </b-form-group>
          <b-form-group label="Alias" label-for="service-alias">
            <small class="text-danger" v-show="aliasNotSelected"
              >Należy wybrać alias.</small
            >
            <b-form-select
              id="service-alias"
              size="sm"
              v-model="alias"
              :options="aliases"
            >
              <template slot="first">
                <option :value="null" disabled>Wybierz</option>
              </template>
            </b-form-select>
          </b-form-group>
          <b-form-group>
            <b-btn
              type="submit"
              variant="primary"
              class="col-md-12"
              size="sm"
              :disabled="submitting"
            >
              <span v-show="!submitting">Szukaj</span>
              <icon v-show="submitting" name="circle-notch" spin></icon>
            </b-btn>
          </b-form-group>
        </b-form>
      </b-collapse>
      <metadata-search-result
        ref="metadataSearchResult"
      ></metadata-search-result>
    </template>
    <template v-if="true && !isMobileVersion"
      ><b-btn
        class="collapse-btn w-100"
        variant="success"
        v-b-toggle.collapse-layers-search
        @click="toggleCoordinatesSearchCollapsed"
      >
        Wyszukiwanie warstw
        <icon
          class="ml-1"
          v-show="coordinateSearchExpanded"
          name="caret-up"
        ></icon>
        <icon
          class="ml-1"
          v-show="!coordinateSearchExpanded"
          name="caret-down"
        ></icon>
      </b-btn>
      <b-collapse id="collapse-layers-search">
        <layers-search></layers-search></b-collapse
    ></template>
    <loading-overlay
      :active.sync="isLoading"
      :is-full-page="false"
    ></loading-overlay>
  </collapsible-widget>
</template>

<script>
import LoadingOverlay from 'vue-loading-overlay';
import { Api as ServicesApi } from '../api/api-uslugi-mapowe.js';
import { Api as SearchApi } from '../api/api-wyszukiwarka.js';
import CollapsibleWidget from './CollapsibleWidget';
import MetadataSearchResult from './MetadataSearchResult.vue';
import CoordinateSearch from './SidebarSearch/CoordinateSearch.vue';
import MileageSearch from './SidebarSearch/MileageSearch.vue';
import AddressSearch from './SidebarSearch/AddressSearch';
import LayersSearch from './SidebarSearch/LayersSearch';
import TerytSearch from './SidebarSearch/TerytSearch.vue';
import { mapGetters } from 'vuex';
import Autocomplete from 'v-autocomplete';
import AutocompleteItem from './SidebarSearch/AutocompleteItem.vue';
import MetadataFormatter from '../models/MetadataFormatter.js';
import { transformExtent } from 'ol/proj';

export default {
  name: 'SidebarSearchPanel',
  props: {
    accordion: {
      type: String,
      default: 'panel'
    }
  },
  components: {
    CollapsibleWidget,
    MetadataSearchResult,
    CoordinateSearch,
    MileageSearch,
    TerytSearch,
    AddressSearch,
    LayersSearch,
    Autocomplete,
    AutocompleteItem,
    LoadingOverlay
  },
  data() {
    return {
      isLoading: false,
      addressSearchControl: '',
      metadataExpanded: false,
      submitting: false,
      fetchingData: false,
      services: [],
      service: null,
      aliases: [],
      alias: null,
      serviceNotSelected: false,
      aliasNotSelected: false,
      apiError: false,
      downloadErrorMessage: '',
      aliasesDownloadError: false,
      servicesDownloadError: false,
      // FEATURES
      featuresExpanded: false,
      fetchinFeaturesData: false,
      coordinateSearchExpanded: false,
      mileageSearchExpanded: false,
      terytSearchExpanded: false,
      addressSearchExpanded: false
    };
  },
  computed: {
    downloadErrors: {
      get() {
        return this.aliasesDownloadError || this.servicesDownloadError;
      },
      set(value) {
        this.aliasesDownloadError = this.servicesDownloadError = value;
      }
    },
    ...mapGetters([
      'objectSearchTool',
      'metadataSearchTool',
      'addressSearchTool',
      'searchLoading',
      'isMobileVersion'
    ])
  },
  watch: {
    service() {
      if (this.service) {
        this.serviceNotSelected = false;
        this.serviceChanged();
      }
    }
  },
  created() {
    var vm = this;
    this.$store.watch(
      () => vm.$store.getters.searchLoading,
      value => vm.onLoadingChanged(value)
    );
  },
  methods: {
    onLoadingChanged(value) {
      this.isLoading = value;
    },
    async submit(e) {
      e.preventDefault();

      if (this.validate()) await this.metadataSearch();
    },
    async metadataSearch() {
      try {
        this.submitting = true;
        const corners = this.calculateUpperAndLowerCorner();
        const api = new ServicesApi();
        const response = await api.getCswRecords({
          wso2_id: this.contextEmail ? this.contextEmail : null,
          orgid: this.contextOrganizationId ? this.contextOrganizationId : null,
          url: this.service.url,
          filter_key: this.alias.key,
          filter_value: this.alias.value,
          lower_corner: corners[0],
          upper_corner: corners[1]
        });

        if (
          response.body.services['csw:GetRecordsResponse'] &&
          response.body.services['csw:GetRecordsResponse']['csw:SearchResults']
        ) {
          if (
            response.body.services['csw:GetRecordsResponse'][
              'csw:SearchResults'
            ]['@numberOfRecordsReturned'] > 0
          ) {
            const searchResults =
              response.body.services['csw:GetRecordsResponse'][
                'csw:SearchResults'
              ];
            const metadataFormatter = new MetadataFormatter(searchResults);
            const services = metadataFormatter.format();
            const totalRows = +response.body.services['csw:GetRecordsResponse'][
              'csw:SearchResults'
            ]['@numberOfRecordsMatched'];

            setTimeout(
              () =>
                this.showSearchResultModal(
                  services,
                  totalRows,
                  corners[0],
                  corners[1]
                ),
              250
            );
          } else {
            setTimeout(() => this.showSearchResultModal(null), 250);
          }
        } else {
          this.$notify({
            type: 'error',
            title: 'Uwaga!',
            text: 'Pobranie metadanych nie powiodło się.',
            duration: 2000
          });
        }
      } catch (exception) {
        this.showApiError();
      } finally {
        setTimeout(() => (this.submitting = false), 250);
      }
    },
    calculateUpperAndLowerCorner() {
      const currentExtentInMapProjection = this.$store.getters
        .currentViewExtent;
      if (
        !Array.isArray(currentExtentInMapProjection) ||
        currentExtentInMapProjection.length != 4
      ) {
        throw 'Nieprawidłowy zasięg mapy';
      }
      const convertedExtent = transformExtent(
        currentExtentInMapProjection,
        'EPSG:2180',
        'EPSG:4326'
      );
      return [
        `${convertedExtent[0]} ${convertedExtent[1]}`,
        `${convertedExtent[2]} ${convertedExtent[3]}`
      ];
    },
    showSearchResultModal(services, totalRows, lowerCorner, upperCorner) {
      this.apiError = false;
      this.$refs.metadataSearchResult.show(
        services || [],
        this.alias.key,
        this.alias.value,
        this.service.url,
        totalRows,
        lowerCorner,
        upperCorner
      );
    },
    toggleMetadataCollapsed() {
      this.metadataExpanded = !this.metadataExpanded;

      if (this.metadataExpanded) {
        this.fetchMetadataData();
      }
    },
    async fetchMetadataData() {
      this.fetchingData = true;
      const api = new ServicesApi();

      try {
        const response = await api.getUslugiMapowe({
          wso2_id: this.contextEmail ? this.contextEmail : null,
          orgid: this.contextOrganizationId ? this.contextOrganizationId : null
        });
        this.services = response.body.uslugi_mapowe
          .filter(u => u.rodzaj == 'csw')
          .map(u => ({ text: u.nazwa, value: { id: u.id, url: u.adres } }));
        this.downloadErrors = false;
      } catch (exception) {
        this.showAddressDownloadError();
      } finally {
        setTimeout(_ => (this.fetchingData = false), 250);
      }
    },
    async serviceChanged() {
      this.fetchingData = true;
      const serviceId = this.service.id;
      const api = new ServicesApi();
      this.alias = null;

      try {
        const response = await api.getUslugiMapoweById({
          wso2_id: this.contextEmail ? this.contextEmail : null,
          orgid: this.contextOrganizationId ? this.contextOrganizationId : null,
          id: serviceId
        });
        this.aliases = response.body.uslugi_mapowe.pola.map(p => ({
          text: p.alias,
          value: { key: p.key, value: p.value }
        }));
        this.downloadErrors = false;
      } catch (exception) {
        this.showAliasesDownloadError();
      } finally {
        setTimeout(_ => (this.fetchingData = false), 250);
      }
    },
    validate() {
      this.serviceNotSelected = !this.service;
      this.aliasNotSelected = !this.alias;

      return !this.serviceNotSelected && !this.aliasNotSelected;
    },
    clear() {
      this.service = null;
      this.services = [];
      this.aliases = [];
      this.alias = null;
      this.serviceNotSelected = false;
      this.aliasNotSelected = false;
      this.downloadErrors = false;
    },
    showAddressDownloadError() {
      this.downloadErrorMessage = 'Błąd pobierania adresów.';
      this.servicesDownloadError = true;
    },
    showAliasesDownloadError() {
      this.downloadErrorMessage = 'Błąd pobierania aliasów.';
      this.aliasesDownloadError = true;
    },
    showApiError() {
      this.apiError = true;
    },
    refresh() {
      if (this.aliasesDownloadError) {
        this.serviceChanged();
      } else if (this.servicesDownloadError) {
        this.fetchMetadataData();
      }
    },
    // FEATURES
    toggleFeaturesCollapsed() {
      this.featuresExpanded = !this.featuresExpanded;
      if (this.featuresExpanded) {
        this.fetchFeaturesData();
      }
    },
    toggleCoordinatesSearchCollapsed() {
      this.coordinateSearchExpanded = !this.coordinateSearchExpanded;
    },
    toggleMileageSearchCollapsed() {
      this.mileageSearchExpanded = !this.mileageSearchExpanded;
    },
    toggleTerytSearchCollapsed() {
      this.terytSearchExpanded = !this.terytSearchExpanded;
    },
    toggleAddressSearchCollapsed() {
      this.addressSearchExpanded = !this.addressSearchExpanded;
    },
    fetchFeaturesData() {
      this.fetchinFeaturesData = true;
      try {
      } catch (exception) {
      } finally {
        setTimeout(_ => (this.fetchinFeaturesData = false), 1000);
      }
    }
  }
};
</script>

<style scoped>
.fa-icon {
  position: relative;
  top: 0.125em;
}

#address-search-form,
#metadata-form,
#coordinate-search-form,
#mileage-search-form,
#teryt-search-form,
#filter-search-form {
  padding-left: 1em;
  padding-right: 1em;
}

.blur {
  filter: blur(10px);
}

.overlayed-loader {
  position: absolute;
  width: 100%;
  height: 100%;
  display: -webkit-flex;
  display: flex;
  -webkit-align-items: center;
  align-items: center;
  z-index: 2;
}

.overlayed-loader-icon {
  display: -webkit-flex;
  display: flex;
  margin: 0 auto;
}

.collapse-btn {
  border-radius: 0;
  -webkit-flex: none;
  flex: none;
}
</style>
